import "preact/debug"
import { createHashHistory } from "history"
import { render } from "htm/preact"
import Router from "preact-router"

import { RoundTables } from "../components/Roundtables"
import { ElfsightPopup } from "../utils/fw"
import { handleNewRoute } from "../utils/routing"

import { CometChat } from "./components/CometChat"
import { Navbar } from "./components/Navbar"
import { Room } from "./components/Room"

import "./styles.css"
import { assignAchievement } from "src/components/Leaderboard"
import { userID, eventID } from "src/utils/datalayer"

const rooms = [
	{
		background: "https://assets.swoogo.com/uploads/full/1299940-611c03dab8da6.jpg",
		default: true,
		links: [
			{
				elfsightPopupID: "c3133e47-04b0-48f9-9507-2211a70b2b9f",
				elfsightPopupTrigger: "BT-info-desk-pop-up",
				height: "12%",
				label: "Lobby",
				left: "43%",
				top: "13%",
				width: "14%",
			},
			{
				height: "34.3%",
				href: "/Coffee-Talks",
				isExternal: true,
				label: "Coffee Room",
				left: "76.3%",
				top: "29.7%",
				width: "22.2%",
			},
			{
				height: "34.3%",
				href: "/The-Forum",
				isExternal: true,
				label: "The Forum",
				left: "6.3%",
				top: "33.7%",
				width: "13.2%",
			},
			{
				height: "41.2%",
				href: "/The-Lounge",
				isExternal: true,
				label: "Expert Lounge",
				left: "43.9%",
				top: "30.2%",
				width: "12.6%",
			},
		],
		name: "lobby",
	},
	{
		background: "https://assets.swoogo.com/uploads/full/1538934-61e13cfa80440.jpg",
		links: [
			{
				elfsightPopupID: "e855aac9-06a2-4b74-abc8-5d65e552e366",
				elfsightPopupTrigger: "BT-corp-new-firms-pop-up",
				height: "14.5%",
				label: "Lobby",
				left: "12.7%",
				top: "17.0%",
				width: "12.2%",
			},
			{
				width: "15.5%",
				height: "8.4%",
				top: "45.1%",
				left: "74.9%",
				label: "Talk to Chris",
				onClick: () => {
					assignAchievement({
						entrypoint: "https://leaderboardb.swoogo-retrofit.tkevents.io",
						achievementId: "5fc77003-973e-4c44-aebd-91bb47741cef",
						eventId: eventID,
						userId: userID
					})

					window.openZoom("chris")
				},
			},
			{
				width: "15.5%",
				height: "8.4%",
				top: "25.1%",
				left: "74.9%",
				label: "Talk to Trish",
				onClick: () => {
					assignAchievement({
						entrypoint: "https://leaderboardb.swoogo-retrofit.tkevents.io",
						achievementId: "a4616f42-8249-48e8-aa4b-84ef34dd9441",
						eventId: eventID,
						userId: userID
					})

					window.openZoom("trish")
				},
			},
			{
				width: "15.5%",
				height: "8.4%",
				top: "35.1%",
				left: "74.9%",
				label: "Talk to Claire",
				onClick: () => {
					assignAchievement({
						entrypoint: "https://leaderboardb.swoogo-retrofit.tkevents.io",
						achievementId: "f7b636a3-9139-48b7-919e-c6020c7c330b",
						eventId: eventID,
						userId: userID
					})

					window.openZoom("nat")
				},
			},
		],
		name: "Coffee Talks",
	},
	{
		background: "https://assets.swoogo.com/uploads/full/990657-6065e8d35f8a7.jpg",
		extras: (
			<>
				<iframe
					style={{position: "absolute",	left: "24%", top: "4.7%", width: "52.2%", border: "0", height: "59%",}}
					id="screen"
					src="https://8x8.vc/vpaas-magic-cookie-4259c4d2028945bdb8d111f1b2f27c68/Main Stage"
				/>
			</>
		),
		links: [],
		name: "The Forum",
	},
	{
		background: "https://assets.swoogo.com/uploads/full/1111510-609a75410c171.jpg",
		extras: <RoundTables />,
		links: [],
		name: "The Lounge",
	},
]

const popups = [
	{
		ID: "c3133e47-04b0-48f9-9507-2211a70b2b9f",
		trigger: "BT-info-desk-pop-up",
	},
	{
		ID: "e855aac9-06a2-4b74-abc8-5d65e552e366",
		trigger: "BT-corp-new-firms-pop-up",
	},
]

render(
	<>
		<Navbar />
		<Router
			history={createHashHistory()}
			onChange={handleNewRoute(43458, 1337)}
		>
			{rooms.map(Room)}
		</Router>
		{popups.map(ElfsightPopup)}
		<script src="https://apps.elfsight.com/p/platform.js" defer />
		<CometChat />
	</>,
	document.getElementById("content"),
)
